export default __webpack_public_path__ + "static/screeny-110-gpz-unica-am-1-279a632839ed0dd2d10915339398dcf0.jpg";